import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import MenuBar from '~app/features/menu/components/MenuBar';
import { useT, useResources } from '~app/core/BundleProvider';
import { Link } from 'react-router-dom';
import AriaModal from 'react-aria-modal';
import ConfirmationDialog from '~app/features/app/components/ConfirmationDialog';
import { actions as CanvasActions } from '~app/features/canvas';
import { actions as DocumentActions } from '~app/features/document';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

const MainHeader = ({ hasMenu, hasExit, hasExitToHome }) => {
  const history = useHistory();
  const t = useT();
  const r = useResources();
  const dispatch = useDispatch();
  const [showExitConfirmation, setShowExitConfirmation] = useState(false);
  const doc = useSelector(state => state.document);
  const inGradingMode = useSelector(state => state.grading.inGradingMode);

  const exitCanvas = () => {
    dispatch(CanvasActions.exitComparisonState());
    if (doc.present?.isModified === true && inGradingMode === false) {
      setShowExitConfirmation(true);
    } else {
      dispatch(DocumentActions.closeModel());
    }
  };

  const forceExitCanvas = () => {
    setShowExitConfirmation(false);
    dispatch(DocumentActions.closeModel());
  };

  const exitPage = () => {
    history.goBack();
  };

  const exitToHome = () => {
    history.push('/');
  };

  return (
    <div
      role="navigation"
      aria-label="Main Menu"
      className="MainHeader__container"
    >
      <div className="MainHeader__title-container">
        <img
          className="MainHeader__logo"
          src={r('ModelBuilderLogo.svg')}
          alt="Model Builder Logo"
        />
        <div className="MainHeader__title" role="heading" aria-level="1">
          <Link to="/" onClick={exitCanvas}>
            {t('html-title')}
          </Link>
        </div>
      </div>
      {hasMenu && (
        <div className="MainHeader__right-side">
          <MenuBar exitCanvas={exitCanvas} />
        </div>
      )}
      {(hasExit || hasExitToHome) && (
        <div className="MainHeader__right-side">
          <Link to="#" onClick={hasExit ? exitPage : exitToHome}>
            <img
              className="MainHeader__logo"
              src={r('close.svg')}
              alt={t('exit-helper')}
            />
          </Link>
        </div>
      )}
      <AriaModal
        mounted={showExitConfirmation}
        titleText={t('confirm-exit-title')}
      >
        <ConfirmationDialog
          title={t('confirm-exit-title')}
          text={t('confirm-exit-text')}
          okLabel={t('discard-button')}
          cancelLabel={t('cancel-button')}
          onOk={() => forceExitCanvas()}
          onCancel={() => setShowExitConfirmation(false)}
        />
      </AriaModal>
    </div>
  );
};

export default MainHeader;
